import script from "./GoogleReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleReviews.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleReviews.vue?vue&type=style&index=0&id=390e8942&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390e8942"]])

export default __exports__